// @link try this later: sg/mt/mt-client-ts/src/lib/inject/rollup.ts

const M = Math

export const min = M.min
export const max = M.max
export const abs = M.abs
export const sin = M.sin
export const cos = M.cos
export const tan = M.tan
export const atan = M.atan
export const atan2 = M.atan2
export const tanh = M.tanh
export const ceil = M.ceil
export const floor = M.floor
export const exp = M.exp
export const pow = M.pow
export const log = M.log
export const sqrt = M.sqrt
export const random = M.random
export const round = M.round
export const sign = M.sign
export const hypot = M.hypot
export const PI = M.PI
export const SQRT2 = M.SQRT2
export const SQRT1_2 = M.SQRT1_2

/** 6.28318530718 */
export const TWO_PI = PI * 2

/** 1.57079632679 */
export const HALF_PI = PI / 2
